import sanityClient from "@sanity/client";

export default sanityClient({ projectId: "8vth77qi", dataset: "production" });
